//@flow
import { compose, withPropsOnChange } from 'recompose'
import withConfig from './withConfig'

const withSettings = (...settings: string[]) =>
  compose(
    withConfig,
    withPropsOnChange(['config'], props => {
      if (!props.config) return {}
      return (settings || []).reduce((acc, settingKey) => {
        acc[settingKey] = props.config[settingKey]
        return acc
      }, {})
    })
  )

export default withSettings



// WEBPACK FOOTER //
// ./src/modules/config/withSettings.js